<template>
  <div class="mail_detail" v-if="message != null">
    <section class="no_padding">
      <h2>{{ title }}</h2>

      <div v-if="message != null" class="mail_detail_box">
        <div class="mail_detail_box_title">
          <div class="mail_detail_box_actor">
            <label>{{ actorLabel }}</label><span>{{ actor.name }}</span>
          </div>
          <div class="mail_detail_box_date">{{ message.sent_at }}</div>
        </div>
        <div class="mail_detail_box_text">
          <p>{{ message.body }}</p>
        </div>
        <div
          :class="{
            mail_detail_box_link: isShowLink
          }"
        >
          <p v-if="type !== 'received'"><a href="#" class="btn arrow" @click.prevent="goActorMessage(actor.id)">返信する</a></p>
          <p v-if="image != null && image !== false"><a href="#" class="btn arrow" @click.prevent="openImage()">{{ attachImageLabel }}</a></p>
        </div>
      </div>
    </section>
    <section class="mail_detail_link text_center">
      <p>
        <a href="#" class="arrow link_main--text" @click.prevent="goBack">{{ linkWord }}メールBOX一覧に戻る</a>
      </p>
    </section>
  </div>
  <div v-else-if="isNotFound">
    <NotFound />
  </div>
</template>

<script>
import store from '@/store'
import { GET_ACTOR_BY_SEND_MESSAGE } from '@/store/actor/actions'
import { GET_TOP } from '@/store/top/actions'
import {
  GET_MESSAGE,
  GET_MESSAGE_IMAGE
} from '@/store/message/actions'
import { FETCH_MESSAGE } from '@/store/message/mutations'
import NotFound from '@/components/404.vue'

export default {
  name: 'MailDetail',
  components: {
    NotFound
  },
  data () {
    return {
      type: this.$route.params.type,
      id: this.$route.params.id,
      message: this.$store.getters.message || null,
      actor: (this.$store.getters.message != null) ? this.$store.getters.message.actor || null : null,
      image: (this.$store.getters.message != null) ? this.$store.getters.message.image || null : null,
      isNotFound: false
    }
  },
  computed: {
    title () {
      let titleStr = '鑑定結果詳細'
      if (this.type === 'received') {
        titleStr = '鑑定依頼詳細'
      }
      return titleStr
    },
    actorLabel () {
      let titleStr = '差出人'
      if (this.type === 'received') {
        titleStr = '宛先'
      }
      return titleStr
    },
    attachImageLabel () {
      let titleStr = '添付画像を開封する'
      if (this.type === 'received') {
        titleStr = '添付画像を確認'
      }
      return titleStr
    },
    linkWord () {
      let str = ''
      switch (this.type) {
        case 'new':
          str = '新着'
          break
        case 'received':
          str = '送信'
          break
        case 'read':
          str = '既読'
          break
      }
      return str
    },
    isShowLink () {
      let isShow = true
      if (!this.image && this.type === 'received') {
        isShow = false
      }
      return isShow
    }
  },
  methods: {
    getMessage () {
      this.$store.dispatch(GET_MESSAGE, {
        id: this.id,
        params: {
          params: {
            type: this.type
          }
        }
      })
        .then(data => {
          // メールを既読にすることでヘッダーの更新を行う
          this.$store.dispatch(GET_TOP)
            .then(() => {})
            .catch(() => {})

          this.message = data
          this.actor = data.actor
          this.image = data.image
        })
        .catch((error) => {
          if (error.errorStatus === 404) {
            this.isNotFound = true
          } else {
            this.$router.go(-1)
          }
        })
    },
    goActorMessage (actorId) {
      this.$store.dispatch(GET_ACTOR_BY_SEND_MESSAGE, {
        id: actorId
      })
        .then((data) => {
          if (data.is_point_shortage) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          } else {
            this.$router.pushIsses({ name: 'ActorMessage', params: { id: actorId } })
          }
        })
        .catch(() => {})
    },
    openImage () {
      this.$store.dispatch(GET_MESSAGE_IMAGE, {
        id: this.id,
        params: {
          params: {
            type: this.type
          }
        }
      })
        .then((data) => {
          this.$router.pushIsses({ name: 'MailImage', params: { id: this.id } })
        })
        .catch((error) => {
          if (error.errorStatus === 402) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          }
        })
    },
    goBack () {
      switch (this.type) {
        case 'new':
          this.$router.pushIsses({ name: 'MailBoxNew', params: { actor_id: this.actor.id } })
          break
        case 'received':
          this.$router.pushIsses({ name: 'MailBoxReceived', params: { actor_id: this.actor.id } })
          break
        case 'read':
          this.$router.pushIsses({ name: 'MailBoxRead', params: { actor_id: this.actor.id } })
          break
      }
    }
  },
  created () {
    this.getMessage()
  },
  beforeRouteEnter (to, from, next) {
    if (!(from.name === 'MailImage' || from.name === 'ActorMessage' || from.name === 'UserPointShortage')) {
      store.commit(FETCH_MESSAGE, null)
    }
    next()
  }
}
</script>
